import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';

type FilterState = {
  setInStockOnly:boolean;
  selectedTags: string[];
  selectedSizes: string[];
  selectedBrands: string[];
  selectedRatings: number[];
  selectedCategories: string[];
};

const initialState: FilterState = {
  setInStockOnly:false,
  selectedTags: [],
  selectedSizes: [],
  selectedBrands: [],
  selectedRatings: [],
  selectedCategories: [],
};

export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    setSelectedTags: (state, action: PayloadAction<string[]>) => {
      state.selectedTags = action.payload;
    },
    setSelectedBrands: (state, action: PayloadAction<string[]>) => {
      state.selectedBrands = action.payload;
    },
    setSelectedSizes: (state, action: PayloadAction<string[]>) => {
      state.selectedSizes = action.payload;
    },
    setSelectedRatings: (state, action: PayloadAction<number[]>) => {
      state.selectedRatings = action.payload;
    },
    setSelectedCategories: (state, action: PayloadAction<string[]>) => {
      state.selectedCategories = action.payload;
    },
    setInStockOnly: (state, action: PayloadAction<boolean>) => {
      state.setInStockOnly = action.payload;
    },
    resetFilters: state => {
      state.selectedTags = [];
      state.selectedSizes = [];
      state.selectedBrands = [];
      state.selectedRatings = [];
      state.selectedCategories = [];
      state.setInStockOnly = false;
    },
  },
});

export const {
  resetFilters,
  setSelectedTags,
  setSelectedSizes,
  setSelectedBrands,
  setSelectedRatings,
  setSelectedCategories,
  setInStockOnly,
} = filterSlice.actions;
